/* eslint-disable no-undef */
(function () {
  'use strict'
  angular.module('MktzapApp.Factories')
    .factory('ReportUserEventsService', reportUserEventsService)

  reportUserEventsService.$inject = ['$resource']

  function reportUserEventsService ($resource) {
    return $resource('', {}, {
      getUserEvents: { url: apiUrl + '/reports/user-events', method: 'GET', params: {}, isArray: false }
    })
  }
// eslint-disable-next-line semi
})();
